import React from "react";
import { ShieldAlert } from "lucide-react";
import dayjs from "dayjs";

const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const FLAG_STYLE = {
  SPOOFED_GPS:     { color: "text-red-400",    bg: "bg-red-500/10 border-red-500/20",       label: "Spoofed GPS"      },
  IMPOSSIBLE_TRAVEL:{ color: "text-red-400",   bg: "bg-red-500/10 border-red-500/20",       label: "Impossible Travel"},
  DEVICE_MISMATCH: { color: "text-orange-400", bg: "bg-orange-500/10 border-orange-500/20", label: "Device Mismatch"  },
  OUTSIDE_GEOFENCE:{ color: "text-yellow-400", bg: "bg-yellow-500/10 border-yellow-500/20", label: "Outside Geofence" },
  VPN_DETECTED:    { color: "text-blue-400",   bg: "bg-blue-500/10 border-blue-500/20",     label: "VPN Detected"     },
};

export default function GeoIntegrity({ loading, data }) {
  const summary = data?.summary || [];
  const recent  = data?.recent  || [];

  const critical = summary.filter(s => ["SPOOFED_GPS","IMPOSSIBLE_TRAVEL"].includes(s.type)).reduce((a, b) => a + (b.count || 0), 0);

  if (loading) return (
    <div className={`${card} p-5`}>
      <div className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium mb-4">Geo & Device Integrity</div>
      <div className="h-48 rounded-lg bg-white/5 animate-pulse" />
    </div>
  );

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <ShieldAlert size={14} className="text-[#00ff90]/60" />
          <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Geo & Device Integrity</span>
        </div>
        {critical > 0 && (
          <span className="text-xs text-red-400 bg-red-500/10 border border-red-500/20 px-2 py-0.5 rounded-full">
            {critical} critical
          </span>
        )}
      </div>

      <div className="p-5 space-y-4">

        {/* Summary chips */}
        {summary.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {summary.map((s, i) => {
              const cfg = FLAG_STYLE[s.type] || { color: "text-white/40", bg: "bg-white/5 border-white/10", label: s.type };
              return (
                <span key={i} className={`flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg border ${cfg.bg}`}>
                  <span className={`font-medium ${cfg.color}`}>{s.count}</span>
                  <span className="text-white/40">{cfg.label}</span>
                </span>
              );
            })}
          </div>
        )}

        {/* Recent flags table */}
        {recent.length === 0 ? (
          <p className="text-white/20 text-sm italic text-center py-2">No recent integrity flags.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-xs">
              <thead>
                <tr className="border-b border-white/5">
                  {["ID","Type","Dept","Location","Date"].map(h => (
                    <th key={h} className="px-3 py-2 text-left text-[#00ff90]/40 uppercase tracking-wider font-medium">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {recent.map(r => {
                  const cfg = FLAG_STYLE[r.type] || { color: "text-white/40", bg: "bg-white/5 border-white/10", label: r.type };
                  return (
                    <tr key={r.id} className="border-b border-white/5 hover:bg-white/3 transition-colors">
                      <td className="px-3 py-2 font-mono text-white/30">{r.id}</td>
                      <td className="px-3 py-2">
                        <span className={`text-xs px-2 py-0.5 rounded-full border ${cfg.bg} ${cfg.color}`}>
                          {cfg.label}
                        </span>
                      </td>
                      <td className="px-3 py-2 text-white/40">{r.dept}</td>
                      <td className="px-3 py-2 text-white/40">{r.location}</td>
                      <td className="px-3 py-2 text-white/25">
                        {r.date ? dayjs(r.date).format("DD MMM YYYY") : "—"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}